<template>
  <div id="app" class="w-full max-w-4xl mx-auto font-sans">
    <loading :active.sync="loading"></loading>
    <div class="w-full h-screen">
      <div
        class="w-full bg-green-900 text-green-100 flex items-center justify-between py-4 px-6"
        id="nav"
        v-if="$auth.check()"
      >
        <router-link to="/"><span @click="play">💰</span></router-link>
        <div>
          <router-link to="/" class="mr-2 hover:text-green-200"
            ><font-awesome-icon :icon="['fas', 'home']"
          /></router-link>
          <router-link to="/settings" class="mr-2 hover:text-green-200"
            ><font-awesome-icon :icon="['fas', 'cogs']"
          /></router-link>
          <a href="#" class="hover:text-green-200" @click="logout"
            ><font-awesome-icon :icon="['fas', 'sign-out-alt']"
          /></a>
        </div>
      </div>

      <router-view />
      <modals-container />

      <div class="absolute left-0 bottom-0 pl-4 pb-4" v-show="playing">
        <a href="#" @click="play"
          ><font-awesome-icon :icon="['fas', 'stop-circle']" size="4x"
        /></a>
        <audio src="/money.mp3" type="audio/mpeg" ref="audio" />
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay"
import { EventBus } from "./events"

export default {
  name: "App",
  components: { Loading },
  data() {
    return {
      loading: false,
      playing: false,
      timeOut: null,
    }
  },
  watch: {
    "$auth.watch.loaded": {
      handler: function (val) {
        if (!val) this.loading = true
        else this.loading = false
      },
      immediate: true,
    },
  },
  methods: {
    play() {
      if (this.$refs.audio.paused) {
        this.$refs.audio.play()
        this.playing = true
        this.timeOut = setTimeout(() => {
          this.playing = false
        }, 24000)
      } else {
        this.$refs.audio.pause()
        this.$refs.audio.currentTime = 0
        this.playing = false
        clearTimeout(this.timeOut)
        this.timeOut = null
      }
    },
    logout() {
      this.$auth.logout({
        redirect: "/login",
      })
    },
  },
  mounted() {
    EventBus.$on("loading:start", () => (this.loading = true))
    EventBus.$on("loading:end", () => (this.loading = false))
    this.$refs.audio.volume = 0.05
  },
}
</script>

<style lang="scss">
.router-link-exact-active {
  @apply text-green-300;
}
</style>
